export default __webpack_public_path__ + "static/media/Gymnastics Hall, Ambala3.80ff6a21.jpg";